import { useCallback } from "react"
import type { FactorRuleDisplay, FactorRuleDisplayType, FactorRuleField } from "../types"
import { FactorRulesTable } from "./table"

import "./style.scss"

export interface FactorRulesProps {
  hasBase: boolean
  exposure: FactorRuleDisplay[]
  composition: FactorRuleDisplay[]
  exposureError: Error | null
  compositionError: Error | null
  updateFactorRule: (rule: FactorRuleDisplay, field: FactorRuleField, value: string, ruleDisplayType: FactorRuleDisplayType) => void
  removeFactorRule: (rule: FactorRuleDisplay, ruleDisplayType: FactorRuleDisplayType) => void
  toggleActiveValue?: (rule: FactorRuleDisplay, ruleDisplayType: FactorRuleDisplayType) => void
}

export default function FactorRules({
  exposureError,
  compositionError,
  hasBase,
  exposure,
  composition,
  updateFactorRule,
  removeFactorRule,
  toggleActiveValue,
}: FactorRulesProps) {
  const handleRemoveRule = useCallback((rule: FactorRuleDisplay, ruleDisplayType: FactorRuleDisplayType) => {
    if (rule?.id) {
      removeFactorRule(rule, ruleDisplayType)
    }
  }, [removeFactorRule])

  const handleUpdateRule = useCallback((rule: FactorRuleDisplay, field: FactorRuleField, value: string | undefined, ruleDisplayType: FactorRuleDisplayType) => {
    if (rule?.id && value !== undefined) {
      updateFactorRule(rule, field, value, ruleDisplayType)
    }
  }, [updateFactorRule])

  const handleToggleActiveValue = useCallback((rule: FactorRuleDisplay, ruleDisplayType: FactorRuleDisplayType) => {
    if (rule?.id && toggleActiveValue) {
      toggleActiveValue(rule, ruleDisplayType)
    }
  }, [toggleActiveValue])

  return (
    <div className="factor-rules-tables-container">
      <FactorRulesTable
        rules={exposure}
        error={exposureError}
        hasBase={hasBase}
        handleUpdateRule={handleUpdateRule}
        handleRemoveRule={handleRemoveRule}
        handleToggleActiveValue={handleToggleActiveValue}
        ruleDisplayType="exposure"
      />
      <FactorRulesTable
        rules={composition}
        error={compositionError}
        hasBase={hasBase}
        handleUpdateRule={handleUpdateRule}
        handleRemoveRule={handleRemoveRule}
        handleToggleActiveValue={handleToggleActiveValue}
        ruleDisplayType="composition"
      />
    </div>
  )
}
